export const constantMobileRoutes = [
    {
        path: "*",
        redirect: '/mobile',
    },{
    path: "/mobile",
    name: "mobile",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../modules/mobile/Mobile.vue"),
    redirect: '/mobile/home',
},
{
    path: "/mobile/home",
    name: "mobile-home",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/home.vue"),
},
{
    path: "/mobile/case",
    name: "mobile-case",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/case/case.vue"),
},
{
    path: "/mobile/case/detail",
    name: "mobile-case-detail",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/case/case-detail.vue"),
},
{
    path: "/mobile/product",
    name: "mobile-product",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/product/product.vue"),
},
{
    path: "/mobile/product/detail",
    name: "mobile-product-detail",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/product/product-detail.vue"),
},
{
    path: "/mobile/aboutus",
    name: "mobile-aboutus",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/aboutus.vue"),
},
{
    path: "/mobile/news",
    name: "mobile-news",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/news/news.vue"),
}, {
    path: "/mobile/news/detail",
    name: "mobile-news-detail",
    component: () =>
        import( /* webpackChunkName: "overview" */ "../../views/mobile/news/news-detail.vue"),
},];

export default{
    constantMobileRoutes
}
